import { collectNoteSearch } from '../views/notes/search.js';
import { getTaskFilter, setTaskFilter, bindTaskFilter, TASK_FILTER_EVENT } from '../ui/note-task-filter.js';
import { registerSearchNavigation } from '../ui/search-navigation.js';
import { highlightSearchContent, clearSearchHighlights, revealSearchRange } from '../ui/search-content.js';

export function getMobileNoteResults(callbacks, uiState) {
  const task = getTaskFilter(callbacks.sharedCallbacks);
  return collectNoteSearch(callbacks.sharedCallbacks, { query: uiState.notesSearchQuery, task, mainOnly: !task });
}

export function getMobileNoteMatches(callbacks, uiState) {
  return getMobileNoteResults(callbacks, uiState).matches;
}

export function bindMobileNoteSearch(container, deps) {
  const host = container.querySelector('.mobile-notes-view');
  if (!host) { clearSearchHighlights('orbital-mobile-note-search'); return () => {}; }
  const {callbacks, uiState, scheduleRender, ensurePendingEditsSavedBeforeNavigation, clearNoteEditDraft} = deps;
  const input = host.querySelector('[data-mobile-action="note-search"]');
  const controller = new AbortController();
  function step(direction) {
    const matches = getMobileNoteMatches(callbacks,uiState);
    if (!matches.length) return;
    const index = matches.findIndex(match => match.key === uiState.noteSearchMatch);
    const next = matches[(index < 0 ? (direction > 0 ? 0 : matches.length - 1) : index + direction + matches.length) % matches.length];
    if ((next.noteId !== uiState.activeNoteId || next.docId !== (uiState.activeNoteDocId || null)) && !ensurePendingEditsSavedBeforeNavigation()) return;
    if ((next.noteId !== uiState.activeNoteId || next.docId !== (uiState.activeNoteDocId || null))) {
      uiState.noteEditing = false; uiState.editingNoteContext = null; clearNoteEditDraft();
    }
    uiState.activeNoteId = next.noteId;
    uiState.activeNoteDocId = next.docId;
    uiState.noteSearchMatch = next.key;
    uiState.noteSearchReveal = true;
    scheduleRender();
  }
  const navigation = registerSearchNavigation({
    available:() => host.isConnected && !!host.getClientRects().length,
    contains:target => host.contains(target), hasQuery:() => !!uiState.notesSearchQuery.trim() || !!getTaskFilter(callbacks.sharedCallbacks),
    focus:() => {input.focus({preventScroll:true});input.select();}, next:step,
  });
  input.addEventListener('focus',navigation.activate,{signal:controller.signal});
  input.addEventListener('keydown',event => {
    if (event.isComposing || !['Enter','Escape'].includes(event.key)) return;
    event.preventDefault();event.stopPropagation();
    if (event.key === 'Escape') {
      if (uiState.notesSearchQuery) uiState.notesSearchQuery = '';
      else if (getTaskFilter(callbacks.sharedCallbacks)) setTaskFilter(null);
      uiState.noteSearchMatch = null; scheduleRender();
    } else step(event.shiftKey ? -1 : 1);
  },{signal:controller.signal});
  host.querySelectorAll('[data-note-find]').forEach(button => button.addEventListener('click',()=>{
    navigation.activate(); step(Number(button.dataset.noteFind));
  },{signal:controller.signal}));
  bindTaskFilter(host, callbacks.sharedCallbacks, {signal: controller.signal, beforeChange: ensurePendingEditsSavedBeforeNavigation});
  document.addEventListener(TASK_FILTER_EVENT, event => {
    if (event.detail?.resetQuery) uiState.notesSearchQuery = '';
    uiState.noteSearchMatch = null;
    scheduleRender();
  }, {signal: controller.signal});
  host.querySelector('.mobile-note-list')?.addEventListener('keydown', event => {
    if (!['ArrowUp', 'ArrowDown'].includes(event.key) || event.ctrlKey || event.metaKey || event.altKey || event.isComposing) return;
    const row = event.target.closest('.mobile-note-row');
    if (!row) return;
    event.preventDefault(); event.stopPropagation();
    const next = event.key === 'ArrowUp' ? row.previousElementSibling : row.nextElementSibling;
    if (next?.matches('.mobile-note-row')) { uiState.noteSearchFocusList = true; next.click(); }
  }, {signal: controller.signal});
  if (uiState.noteSearchFocusList) {
    host.querySelector('.mobile-note-row.active')?.focus({ preventScroll: true });
    uiState.noteSearchFocusList = false;
  }
  const match = getMobileNoteMatches(callbacks,uiState).find(match => match.key === uiState.noteSearchMatch);
  const body = host.querySelector('.mobile-notes-rendered, .mobile-note-editor-mount .ProseMirror');
  const range = highlightSearchContent(body, uiState.notesSearchQuery,
    match?.noteId === uiState.activeNoteId && match.docId === (uiState.activeNoteDocId || null) && match.field === 'body' ? match.occurrence : -1,'orbital-mobile-note-search');
  if (uiState.noteSearchReveal) {
    revealSearchRange(range,host.querySelector('.mobile-note-reader'));
    const row = host.querySelector('.mobile-note-row.active');
    const list = host.querySelector('.mobile-note-list');
    if (row && list) {
      const r = row.getBoundingClientRect(), box = list.getBoundingClientRect();
      if (r.left < box.left || r.right > box.right) list.scrollLeft += r.left - box.left;
    }
    uiState.noteSearchReveal = false;
  }
  return () => {controller.abort();navigation.dispose();clearSearchHighlights('orbital-mobile-note-search');};
}
